import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useListUserServices = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ userServices, setUserServices ] = useState([]);
    const [ fetchingUserServices, setFetchingUserServices ] = useState(true);

    /** list contracts
    * @returns {array} - array of users */ 
    const listUserServices = async (userID) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingUserServices')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/users/" + userID + "/services", options);

            removeMessage(msgId);

            if (result && result.status === 200 && result.data) {
                setUserServices(result.data);
                setFetchingUserServices(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.userServicesNotFound') });
                setFetchingUserServices(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingUserServicesFailed') });
            setFetchingUserServices(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingUserServicesFailed') });
            setFetchingUserServices(false);
            return error;
        }
    }

    return { userServices, fetchingUserServices, listUserServices };

}

export default useListUserServices;
